import _ from "lodash";
import ParseUser from "@/helpers/ParseUser";
import { SAVE_PROJECT_USERS, SAVE_PROJECTS } from "@/store/mutation-types";
import ApiRequest from "../../helpers/ApiRequest";
import GetHeaders from "../../helpers/GetHeaders";

export default {
  actions: {
    addUserToProject: async (_, payload) => {
      return ApiRequest.explorePost(
        "projects/" + payload.projectId + "/users/" + payload.userId,
        {},
        GetHeaders.projectHeaders()
      ).then(() => {
        return true;
      });
    },
    loadProjectUsers: async ({ commit }, payload) => {
      return ApiRequest.exploreGet(
        "projects/" + payload.id + "/users",
        GetHeaders.projectHeaders()
      ).then(res => {
        const mappedUsers = ParseUser.parseArray(res.data);
        commit(SAVE_PROJECT_USERS, { users: mappedUsers });
      });
    },
    addModelToProject: async (_, payload) => {
      return ApiRequest.explorePost(
        "projects/" + payload.projectId + "/models",
        {
          pool_ids: payload.pool_ids,
          topicing_method: payload.topicing_method,
          name: payload.name,
          description: payload.description,
          topicing_id: payload.topicing_id
        },
        GetHeaders.projectHeaders()
      ).then(res => {
        return res.data;
      });
    },
    deleteProject: async ({ dispatch }, payload) => {
      return ApiRequest.exploreDelete(
        "projects/" + payload.projectId,
        GetHeaders.projectHeaders()
      ).then(() => {
        dispatch("loadProjects");
      });
    },
    leaveProject: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "leave_project/" + payload.project_id, payload,
        GetHeaders.projectHeaders()
      ).then(() => {
        dispatch("loadProjects");
      });
    },
    loadProject: async (_, payload) => {
      return ApiRequest.exploreGet(
        "projects/" + payload.id,
        GetHeaders.projectHeaders()
      )
      .then(res => {
        return res.data;
      })
    },
    loadProjects: async ({ commit }) => {
      return ApiRequest.exploreGet(
        "projects",
        GetHeaders.projectHeaders()
      ).then(res => {
        commit(SAVE_PROJECTS, { projects: res.data });
        return res.data;
      })
    },
    saveProject: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "projects",
        payload.project,
        GetHeaders.projectHeaders()
      ).then(res => {
        if(!("refresh" in payload)){
          dispatch("loadProjects");
        }
        return res.data;
      });
    },
    updateProject: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "projects/" + payload.projectId,
        payload.project,
        GetHeaders.projectHeaders()
      ).then(() => {
        dispatch("loadProjects");
      });
    },
    removeUserFromProject: async (_, payload) => {
      return ApiRequest.exploreDelete(
        "projects/" + payload.projectId + "/users/" + payload.userId,
        GetHeaders.projectHeaders()
      ).then(() => {
        return true;
      });
    }
  },
  getters: {
    projects: state => state.projects,
    projectsByDateDesc: state => _.orderBy(state.projects, "date", "desc"),
    projectsByName: state => _.orderBy(state.projects, "name", "asc")
  },
  mutations: {
    [SAVE_PROJECTS](state, payload) {
      state.projects = payload.projects;
    },
    [SAVE_PROJECT_USERS](state, payload) {
      state.projectUsers = payload.users;
    }
  },
  state: {
    projects: [],
    projectUsers: []
  }
};
